/**
 * Byte-buffer helpers.
 *
 * WebCrypto's `BufferSource` parameter type (lib.dom under TS ≥ 5.7) requires
 * an `ArrayBuffer`-backed view, not the wider `ArrayBufferLike` that a generic
 * `Uint8Array` carries. `toArrayBuffer` returns a fresh, exactly-sized
 * `ArrayBuffer` copy that satisfies the type and decouples from any larger
 * pooled backing store. Use it at every `crypto.subtle.*` call site.
 */
/** Copy `view` into a fresh, exactly-sized ArrayBuffer (a valid BufferSource). */
export function toArrayBuffer(view) {
    const out = new ArrayBuffer(view.byteLength);
    new Uint8Array(out).set(view);
    return out;
}
//# sourceMappingURL=bytes.js.map